export default "__VITE_ASSET__CawvPqVn__"